// VITE_MIGRATION: explicit deps so that tool files importing this module
// transitively pull in the helpers/templates/models that the closing IIFE
// arguments below reference at module-eval time. Under Sprockets these
// were loaded by concatenation order; under ESM with glob-hoisted tool
// files, the dep graph must be explicit.
import "./namespace.js";
import "./helpers.js";
import "./templates.js";
import "./models.js";

(function (deepCopy, assert, findTemplate, Section, Event, Component) {
  "use strict";

  // store all the tools here
  var TOOL_PROTOTYPES = {};
  var Tool = (function () {
    // prototype for all tools
    var initialize = function (toolName, component, options) {
      // the config object is optional and has optional properties:
      // element, contextName
      var prototype = TOOL_PROTOTYPES[toolName];
      assert(prototype, "Pagebuilder component tool not found: " + toolName);

      var tool = Object.create(prototype),
        splinter = Object.create(component),
        element = options.element,
        contextName = options.contextName || "",
        config = options.config || {};

      /*
       * Need some way to make sure that when a tool calls component.save, that doesn't
       * trigger it's own update lifecycle. Override the save function here and pass the
       * tool's name in the message, so any listeners will know what tool triggered it.
       * Did it in here because components should not know about tools.
       */
      splinter.save = function () {
        component.save.apply(component, arguments);
        Event.trigger("pb:splinter:" + splinter.name + ":save", tool.name);
        tool.requestRenderedContentRefresh();
      };

      /*
       * reset must run against the same splinter save writes to. Called on this
       * wrapper, the underlying splinter's reset would assign `this.context` on
       * the wrapper itself — an own property that permanently shadows the real
       * splinter's context, so later saves update state the tool no longer reads
       * (slides reordered after an add rendered back in the old order).
       */
      splinter.reset = function () {
        return component.reset.apply(component, arguments);
      };

      tool.component = splinter;
      tool.section = Section.find(component.element);
      tool.element = element;
      tool.classes = splinter.config.classes;
      tool.config = config;
      tool.element.classList.add(toolName + "-tool");
      tool.contextName = options.contextName;
      tool.showIf = config.show_if;

      if (component.name) {
        Event.on("pb:splinter:" + component.name + ":save", tool.dataChanged, tool);
        Event.on("pb:splinter:" + component.name + ":reset", tool.dataChanged, tool);
      } else {
        Event.on("pb:component:save", tool.dataChanged, tool);
      }
      Event.on("pb:component:render", tool.elementChanged, tool);
      return tool;
    };

    var tool = {
      name: "",
      classes: null,
      templateId: "",
      template: null,
      element: null,
      component: null,
      section: null,
      config: null,
      setDefault: function () {
        if (this.component.context == null) {
          var expanded = Component.expandAttribute(this.config);
          if (expanded !== undefined) {
            this.component.save(expanded);
          }
        }
      },
      setState: function (context) {
        // set state for the tool. Gets called on initial load
        // before the tool renders and also before update is called
        // when any data on the component changes.
        // passed in a deep copy of the context.
      },
      update: function (element, context) {
        //tools override
      },
      shouldBeCustomizedOnClick: function () {
        return true;
      },
      markAsCustomized: function () {
        jQuery(this.element).removeClass("shared-value");
      },
      configureCustomization: function (element, context) {
        jQuery(element).addClass("tool");
        // customizations are only applicable for shared components or inherited components
        if (this.component.shared || this.component.inherited) {
          // if the component is customized.
          if (!this.component.isContextCustomized(this.component.name)) {
            // mark the tool as representing a shared value.
            // this causes the tool to be 'disabled' by default.
            jQuery(element).addClass("shared-value");

            // clicking removes the tool-disabling element.
            if (this.shouldBeCustomizedOnClick()) {
              jQuery(element).on(
                "click",
                function (event) {
                  this.markAsCustomized();
                }.bind(this),
              );
            }
          }
        } else {
          jQuery(element).addClass("unique");
        }

        if (this.component.shared) {
          jQuery(element).addClass("shared-component-value");
        }

        if (this.component.inherited) {
          jQuery(element).addClass("inherited-component-value");
        }
      },
      render: function (element, context, config) {
        element = element || this.element;
        context = context === undefined ? deepCopy(this.component.context) : context;
        // Fall back to the tool's own attribute config — a bare re-render (e.g. after
        // a slide reorder) must keep config-driven markup like the label headline.
        var attributeConfig = config || this.config || {};

        // add in the audit timestamps for the component

        if (this.template && this.element) {
          context = this.prepareRenderContext(context);
          var markup = this.template({ context: context, config: attributeConfig });
          element.innerHTML = markup;
          jQuery(element).prepend(jQuery("<div class='shared-component-tooltip'></div>"));
          this.configureCustomization(element, context);
        }
      },
      prepareRenderContext: function (context) {
        // override if necessary to prepare context for rendering
        return context;
      },
      rendered: function () {
        //tools override, called whenever the element changes
      },
      // Asks for the component's server-rendered content again when an attribute configured
      // with `refresh_rendered_content: true` changes value. Such an attribute selects records
      // only the server can resolve. A save that leaves the value unchanged is ignored, because
      // select widgets fire `change` while they initialize.
      requestRenderedContentRefresh: function () {
        if (!this.config || !this.config.refresh_rendered_content) {
          return;
        }

        var value = this.serializedValue();
        if (value !== this.loadedValue) {
          this.loadedValue = value;
          Event.trigger("pb:component:refresh-rendered-content");
        }
      },
      serializedValue: function () {
        var context = this.component.context;
        if (context == null) {
          return "";
        }
        return typeof context === "object" ? JSON.stringify(context) : String(context);
      },
      load: function (component) {
        component = component || this.component;
        this.setDefault();
        this.loadedValue = this.serializedValue();
        var context = deepCopy(this.component.context);
        this.setState(context);
        this.render(this.element, context, this.config);
        this.bind(this.component);

        // if the component we're editing is shared..
        if (component.shared) {
          this.enableRestore();
        } else if (component.inherited) {
          this.enableRestore();
        }
      },
      bind: function (component) {
        //event binding
      },
      unbind: function (element) {
        //unbind events
      },
      dataChanged: function (changedBy) {
        //todo: check if the context has changed, only do this if it has
        //don't call update on the tool that caused the change
        if (this.name !== changedBy) {
          var context = deepCopy(this.component.context);
          this.setState(context);
          this.update(this.element, context);
        }
      },
      elementChanged: function (component) {
        // only update tools for the loaded component
        if (this.component.key === component.key) {
          this.rendered();
        }
      },
      shouldLoad: function (component) {
        //for tools that don't map to attribute names, like resizer or layout/settings tool,
        //they can specify this to check if they should load for a component.
        return false;
      },
      unload: function () {
        Event.off(null, null, this);
      },

      fork: function (element) {
        var tool = initialize(this.name, this.component, {
          element: element,
          contextName: this.component.name,
        });
        return tool;
      },

      enableRestore: function (selector) {
        selector = selector || ".shared-component-options .reset";
        var me = this,
          button = jQuery(this.element).find(selector);
        button.on("click", function (event) {
          me.component.restore(me.component.name);
          me.component.render();

          // we need to reload the tool now to ensure the ui is re-rendered properly.
          // the loader will handle this when we call this tool 'outdated'.
          Event.trigger("pb:tool:outdated", me);
          me.requestRenderedContentRefresh();

          event.preventDefault();
        });
      },

      listenToInput: function (selector) {
        selector = selector || "input";
        var me = this,
          input = jQuery(this.element).find(selector);
        input.on("input", function () {
          me.component.save(input.val());
          me.component.render();
        });
      },

      updateInput: function (selector) {
        selector = selector || "input";
        var input = jQuery(this.element).find(selector),
          start = input[0].selectionStart,
          end = input[0].selectionEnd;

        input.val(this.component.context);
        input[0].setSelectionRange(start, end);
      },

      disableInput: function (selector) {
        selector = selector || "input";
        var input = jQuery(this.element).find(selector);
        if (input != null) {
          input.off("input");
        }
      },
    };

    function Tool(obj) {
      assert(!!obj.name, "Tools must have a name.");
      var newTool = Object.create(tool),
        invalidProps = [
          "load",
          "element",
          "template",
          "dataChanged",
          "elementChanged",
          "unload",
          "fork",
          "listenToInput",
          "updateInput",
          "disableInput",
        ],
        requiredProps = ["name"];

      //check for required properties
      requiredProps.forEach(function (prop) {
        assert(obj.hasOwnProperty(prop), "The '" + prop + "' is required for all tools.");
      });

      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          //todo: bind this?
          assert(
            invalidProps.indexOf(prop) < 0,
            "'" + obj.name + "' can't override the '" + prop + "' property of the base Tool",
          );
          newTool[prop] = obj[prop];
        }
      }
      if (newTool.templateId) {
        newTool.template = findTemplate(newTool.templateId);
      }

      TOOL_PROTOTYPES[newTool.name] = newTool;
      return newTool;
    }

    Tool.initialize = initialize;

    Tool.globalTools = function (component) {
      var toolData = [];

      // add in the other tool prototypes
      for (var toolName in TOOL_PROTOTYPES) {
        if (TOOL_PROTOTYPES.hasOwnProperty(toolName)) {
          var tool = TOOL_PROTOTYPES[toolName];
          if (tool.shouldLoad(component)) {
            toolData.push({ tool: toolName, config: {} });
          }
        }
      }

      return toolData;
    };

    return Tool;
  })(); // end Tool

  // export
  Sparkle.PageBuilder.Tool = Tool;
})(
  Sparkle.PageBuilder.Helpers.deepCopy,
  Sparkle.PageBuilder.Helpers.assert,
  Sparkle.PageBuilder.Templates.findTemplate,
  Sparkle.PageBuilder.Section,
  Sparkle.PageBuilder.Helpers.Event,
  Sparkle.PageBuilder.Component,
);
// end module
